import styled from '@emotion/styled';
import { getStringProduct } from '../../../../utils/utilityFunctions';

export const Wrapper = styled('div')(({ theme, bgcolor, padding, height, margin, flexdirection, borderRadius, bordercolor, justifycontent, alignItems, width }) => ({
  border: bordercolor ? `2px solid ${bordercolor}` : `2px solid ${theme.palette.border.containerborder}`,
  margin: margin || '4px',
  padding: padding || '5px',
  borderRadius: borderRadius || '10px',
  background: bgcolor || '',
  height: height || '',
  width: width || '100%',
  display: 'flex',
  flexDirection: flexdirection || 'column',
  justifyContent: justifycontent,
  alignItems: alignItems || 'center',
  [theme.breakpoints.up('xll')]:{
    border: bordercolor ? getStringProduct(1.25, `2px solid ${bordercolor}`) : getStringProduct(1.25, `2px solid ${theme.palette.border.containerborder}`),
    margin: getStringProduct(1.25, margin || '4px'),
    padding: getStringProduct(1.25, padding || '5px'),
    borderRadius: getStringProduct(1.25, borderRadius || '10px'),
    height: getStringProduct(1.25, height || ''),
    width: getStringProduct(1.25, width) || '100%',
  },
  [theme.breakpoints.up('xlll')]:{
    border: bordercolor ? getStringProduct(1.66, `2px solid ${bordercolor}`) : getStringProduct(1.66, `2px solid ${theme.palette.border.containerborder}`),
    margin: getStringProduct(1.66, margin || '4px'),
    padding: getStringProduct(1.66, padding || '5px'),
    borderRadius: getStringProduct(1.66, borderRadius || '10px'),
    height: getStringProduct(1.66, height || ''),
    width: getStringProduct(1.66, width) || '100%',
  },
  [theme.breakpoints.up('xl4')]:{
    border: bordercolor ? getStringProduct(2.46, `2px solid ${bordercolor}`) : getStringProduct(2.46, `2px solid ${theme.palette.border.containerborder}`),
    margin: getStringProduct(2.46, margin || '4px'),
    padding: getStringProduct(2.46, padding || '5px'),
    borderRadius: getStringProduct(2.46, borderRadius || '10px'),
    height: getStringProduct(2.46, height || ''),
    width: getStringProduct(2.46, width) || '100%',
  },
}));

export const Title = styled('div')(({ theme, fontweight, fontsize, lineheight, textalign, color }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: fontweight || '400',
  fontSize: fontsize || '13px',
  lineHeight: lineheight || '18px',
  color: color || theme.palette.primary,
  whiteSpace: 'nowrap',
  width: '70%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: textalign || 'center',
  [theme.breakpoints.up('xll')]:{
    fontWeight: getStringProduct(1.25, fontweight || '400px'),
    fontSize: getStringProduct(1.25, fontsize || '13px'),
    lineHeight: getStringProduct(1.25, lineheight || '18px'),
  },
  [theme.breakpoints.up('xlll')]:{
    fontWeight: getStringProduct(1.66, fontweight || '400px'),
    fontSize: getStringProduct(1.66, fontsize || '13px'),
    lineHeight: getStringProduct(1.66, lineheight || '18px'),
  },
  [theme.breakpoints.up('xl4')]:{
    fontWeight: getStringProduct(2.46, fontweight || '400px'),
    fontSize: getStringProduct(2.46, fontsize || '13px'),
    lineHeight: getStringProduct(2.46, lineheight || '18px'),
  },
}));
